<template>
    <div class="componentRoot">
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <RouterView />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "billRoot",

    props: [
    ],

    data() {
        return {
        };
    },

    components: {
    },

    watch: {

    },

    computed: {
    },

    methods: {
    },

};
</script>
